import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { PopoverController } from "@ionic/angular";

@Component({
  selector: "app-modal-load-files",
  templateUrl: "./modal-load-files.component.html",
  styleUrls: ["./modal-load-files.component.scss"],
})
export class ModalLoadFilesComponent implements OnInit {
  fileOrUrl: any; // Usamos EventEmitter
  id_option_file: number = 0;
  input_option_tipo: number = 1;
  urlVideo: any;
  image: any;

  constructor(private popoverCtrl: PopoverController) {}

  ngOnInit() {}

  // Emitir la URL del video
  embedVideo() {
    this.fileOrUrl = {
      type: this.input_option_tipo, // 1 para imagen, 2 para video
      file: null,
      url: this.urlVideo,
    };
    this.close();
  }

  // Emitir el archivo subido
  uploadFile(event: any) {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fileOrUrl = {
          type: this.input_option_tipo, // 1 para imagen, 2 para video
          file: file,
          url: e.target.result, // URL de la imagen leída
        };
        this.close();
      };
      reader.readAsDataURL(file);
    }
  }

  // Otros métodos de control
  closeFile() {
    this.id_option_file = 0;
  }

  btnVideoFile() {
    this.input_option_tipo = 2;
  }

  btnImgFile() {
    this.input_option_tipo = 1;
  }

  addFile() {
    this.id_option_file = 1;
    this.input_option_tipo = 1;
  }

  close() {
    this.popoverCtrl.dismiss(this.fileOrUrl);
  }
}
